import styled from "styled-components";
import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { avisos } from "./mockData";
import LogoSifatBrancoHorizontal from "../../assets/imagens/Logomarca Sifat 2019 - Branco Horizontal.png";
import LogoSifatAzulHorizontal from "../../assets/imagens/Logomarca Sifat 2019 - Azul Horizontal.png";
import Warning from "../../assets/icones/warning.png";
import BotaoModelo from "../BotaoModelo";

const ModalCustomizado = styled(Modal)`
  .modal-content {
    width: 430px;
    border-radius: 25px;

    @media (max-width: 430px) {
      width: 100%;
      border-radius: 0;
      margin: 0px;
    }
  }

  .modal-dialog {
    display: flex;
    justify-content: center;
    @media (max-width: 430px) {
      margin: 0;
      padding: 0;
    }
  }

  .modal-body {
    padding: 0px;
  }
`;

const Corpo = styled(Modal.Body)`
  p {
    text-align: center;
    line-height: 1.4;
    padding: 0px 60px;
    font-size: 15px;
  }

  span {
    font-weight: 800;
  }

  br {
    line-height: 0.3;
    font-size: 0.5em;
    margin: -2px 0;
  }
`;

const ContainerImagens = styled.div`
  width: 100%;
  text-align: center;
  background-color: #a80404;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;

  @media (max-width: 430px) {
    border-radius: 0;
  }
`;

const Titulo = styled.h5`
  color: #a80404;
  margin-top: 20px;
  font-weight: 700;
  width: 100%;
  text-align: center;
  font-size: 24px;
`;

const StyledLogoSifatBrancoHorizontal = styled.img`
  width: 8em;
  height: auto;
`;

const StyledLogoSifatAzulHorizontal = styled.img`
  width: 4em;
  height: auto;
`;

const WarningIcon = styled.img`
  width: 3.3em;
  height: auto;
`;

const WarningIconBotao = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 8px;
  transition: all 0.3s ease;
`;

const Ponto = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? "white" : "gray")};
  border: 0.1px solid #cccb;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
  margin: 0 5px;
  cursor: ${(props) => (props.active ? "default" : "pointer")};
`;

const ContainerPontos = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
  gap: 15px;
`;

const SetaNavegacao = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f0f0;
    color: #ccc6;
  }

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }

  &:disabled:hover {
    background-color: transparent;
  }
`;

const ContainerPontosNavegacao = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 46px;
`;

const CardFaleConosco = styled.div`
  background-color: #1b355e;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 16px 16px 0px 16px;
  text-align: center;
  position: absolute;
  bottom: -100px;
  width: 250px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 12px;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContainerPoweredBy = styled.div`
  background-color: white;
  text-align: center;
  color: black;
  font-size: 10px;
  line-height: 1.2;
  padding: 4px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 120px;
  justify-content: center;
  display: flex;
  gap: 4px;
  flex-direction: row;
  margin-top: 8px;
`;

const BotaoIcone = styled.button`
  width: 50px;
  height: 50px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background-color: #fff0;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  /* &:hover {
    width: 70px;
    height: 70px;
    transition: all 0.3s ease;

    img {
      width: 50px;
      height: 50px;
      transition: all 0.3s ease;
    }
  } */

  img {
    width: 35px;
    height: 35px;
    transition: all 0.3s ease;
  }
`;

const BotaoFecharMobile = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.4);
  border: none;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  transition: all 0.3s ease;
  color: white;
  font-size: 20px;
  font-weight: bold;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 450px) {
    display: flex;
  }
`;

// Funções para gerenciar cookies
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

function ModalAvisos() {
  const [mostrar, setMostrar] = useState(false);
  const [avisosAtivos, setAvisosAtivos] = useState([]);
  const [indexAtual, setIndexAtual] = useState(0);
  const [larguraTela, setLarguraTela] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setLarguraTela(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClose = () => {
    setMostrar(false);
    setCookie("mostrarAvisos", "false", 7);
  };
  const handleShow = () => setMostrar(true);

  const proximoAviso = () => {
    setIndexAtual((prev) => (prev + 1) % avisosAtivos.length);
  };

  const avisoAnterior = () => {
    setIndexAtual(
      (prev) => (prev - 1 + avisosAtivos.length) % avisosAtivos.length,
    );
  };

  useEffect(() => {
    const activeAvisos = avisos.filter((aviso) => aviso.ativo);
    setAvisosAtivos(activeAvisos);

    if (activeAvisos.length > 0) {
      setIndexAtual(0);

      const mostrarCookie = getCookie("mostrarAvisos");
      if (mostrarCookie !== "false") {
        setMostrar(true);
      } else {
        setMostrar(false);
      }
    } else {
      setMostrar(false);
    }
  }, []);

  return (
    avisosAtivos[indexAtual] && (
      <>
        {avisosAtivos.length > 0 && larguraTela > 993 ? (
          <BotaoIcone onClick={handleShow}>
            <img src={Warning} alt="Avisos" />
          </BotaoIcone>
        ) : (
          <BotaoModelo
            $backgroundcolor={"#ffff00"}
            color={"#1b355e"}
            texto={"Avisos"}
            temIcone={"true"}
            icone={<WarningIconBotao src={Warning} alt="Avisos" />}
            customOnClick={handleShow}
          />
        )}
        <ModalCustomizado show={mostrar} onHide={handleClose}>
          <BotaoFecharMobile onClick={handleClose}>×</BotaoFecharMobile>
          <ContainerImagens>
            <WarningIcon src={Warning} alt="Icone Warning" />
            <StyledLogoSifatBrancoHorizontal
              src={LogoSifatBrancoHorizontal}
              alt="Logo Sifat"
            />
            <WarningIcon src={Warning} alt="Icone Warning" />
          </ContainerImagens>
          <Titulo>{avisosAtivos[indexAtual].titulo}</Titulo>
          <Corpo>{avisosAtivos[indexAtual].mensagem}</Corpo>
          <ContainerPontos>
            {avisosAtivos.length > 1 ? (
              <ContainerPontosNavegacao>
                <SetaNavegacao
                  onClick={avisoAnterior}
                  disabled={avisosAtivos.length <= 1}
                >
                  &lt;
                </SetaNavegacao>
                {avisosAtivos.map((_, index) => (
                  <Ponto
                    key={index}
                    active={indexAtual === index}
                    onClick={() => setIndexAtual(index)}
                  />
                ))}
                <SetaNavegacao
                  onClick={proximoAviso}
                  disabled={avisosAtivos.length <= 1}
                >
                  &gt;
                </SetaNavegacao>
              </ContainerPontosNavegacao>
            ) : (
              <ContainerPontosNavegacao />
            )}
          </ContainerPontos>
          <CardFaleConosco>
            Fale Conosco <br />
            WhatsApp • (17) 3122-8600 <br />
            Rio Preto e Região • (17) 3122-8600 <br />
            Unidade Ribeirão Preto • (16) 3456-8686 <br />
            Unidade São Paulo • (11) 2832-8600 <br />
            E-mail • contato@sifat.com.br <br />
            Visite nosso site • sifat.com.br
            <ContainerPoweredBy>
              Powered by{" "}
              <StyledLogoSifatAzulHorizontal
                src={LogoSifatAzulHorizontal}
                alt="Logo Sifat"
              />
            </ContainerPoweredBy>
          </CardFaleConosco>
        </ModalCustomizado>
      </>
    )
  );
}

export default ModalAvisos;
